import FAQ from "../pages/FAQ/FAQ.js";

export default [
    {
        path: "/faq",
        component: FAQ,
        isProtected: true,
      },
]